<template>
  <modal-base
    title="Entfernen eines Eintrags"
    ref="modal"
    :okFunction="okFunction"
  >
    <p>
      Sind Sie sicher, dass Sie den ausgewählten Eintrag unwiderruflich
      entfernen möchten?
    </p>
  </modal-base>
</template>

<script>
import ModalBase from "./ModalBase";
import { modalBaseMixin } from "../../mixins/modalBase";

export default {
  name: "RemoveRequestModal",
  components: { ModalBase },
  mixins: [modalBaseMixin],
  props: {
    okFunction: Function
  }
};
</script>

<style scoped></style>
